import { createFileRoute } from "@tanstack/react-router";
import { AdminVenueMetadataTab } from "@/components/admin/pages/AdminVenueMetadataTab";

export const Route = createFileRoute("/pulse-ops-x7k2/target-cities/venue-metadata")({
  component: AdminVenueMetadataTab,
});
